<template>
  <div class="myShare">
    <div class="header" v-if="shareList.length > 0">
      <div class="headerMain">
        <div class="start">问卷</div>
        <div class="end">
          <div class="userName">答题人</div>
          <div class="status">审核状态</div>
          <div class="money">金额</div>
        </div>
      </div>
    </div>
    <div v-if="showEmpty">
      <van-empty description="暂无推广记录~" />
    </div>
    <div class="list">
      <!-- <div class="money" v-if="shareList.length > 0">
        <div class="title">已获得奖励</div>
        <div class="content">
          <span class="num">{{totalMoney || '--'}}</span>
          <span class="unit">元</span>
        </div>
      </div> -->
      <van-list
        v-model="loading"
        :error.sync="error"
        :finished="finished"
        finished-text="没有更多了"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
        <van-notice-bar
          wrapable
          v-if="shareList.length"
          :scrollable="false"
          text="注：答题人名称为红色的代表老用户，老用户答题通过后，您将获得两元红包奖励。"
          class="tips"
        />
        <!-- <div class="tips" v-if="shareList.length">注：答题人名称为红色的代表老用户，老用户答题通过后，您将获得两元红包奖励。</div> -->
        <div v-for="(item, index) in shareList" :key="index" class="reward-item">
          <div class="left">
            <div class="info">
              <div class="name">{{item.qname}}</div>
            </div>
          </div>
          <div class="right">
            <div class="userName" :class="{oldUser: item.isold === 1}">{{item.username}}</div>
            <div class="status" :class="['status_' + item.status]">{{item.status | status}}</div>
            <div class="money">{{item.isold | filterOld}}</div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import { queryTquestion } from "../../api/common"
import store from '../../store/index'
import { formatTime } from '../../util/index'
export default {
  created() {
    const userInfo = store.getters.userInfo
    if (userInfo) {
      this.id = userInfo.user.id
      // this.getList()
    }
  },
  data() {
    return {
      config: {
        pageNum: 0,
        pageSize: 10
      },
      loading: false,
      finished: false,
      error: false,
      shareList: [],
      id: "",
      showEmpty: false,
    };
  },
  methods: {
    async onLoad() {
      this.config.pageNum +=1
      let res = await queryTquestion({ ...this.config, tid: this.id })
      const list1 = res.data.list
      this.shareList = this.shareList.concat(list1)
      this.loading = false
      if (res.data.isLastPage) {
        this.finished = true
      }
    },
    getList() {
      queryTquestion({
        uid: this.id,
        status: "RECEIVED",
      }).then((res) => {
        // 暂时去掉
        // if(res.data.length === 0) {
        //   this.showEmpty = true
        //   return
        // }
        const data = [
          {type: 0, qname: '123123', money: '12'},
          {type: 0, qname: '123123', money: '12'},
          {type: 0, qname: '123123', money: '12'}
        ]
        this.shareList = data || res.data;
      });
    },
  },
  filters: {
    status(val) {
      if (Number(val) === 0 ) {
        return '待审核'
      }
      if (Number(val) === 1 ) {
        return '已通过'
      }
      if (Number(val) === 2 ) {
        return '已拒绝'
      }
      if (Number(val) === 3 ) {
        return '待审核'
      }
      if (Number(val) === 4 ) {
        return '已通过'
      }
    },
    filterOld(val) {
      if (Number(val) === 0 ) {
        return 5
      }
      if (Number(val) === 1 ) {
        return 2
      }
    },
    fmtTime(val) {
      if (val) {
        const res = formatTime(val)
        return `${res.year}/${res.month}/${res.day}   ${res.hour}:${res.minute}:${res.second}`
      }
      return '2019/02/01  19:34:30'
    }
  },
  computed: {
    totalMoney: {
      get() {
        const res = this.shareList.reduce((total, item)=>{
          return Number(total) + Number(item.money)
        }, 0)
        return res
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.myShare {
  min-height: 100vh;
  background: #F2F2F2;
  .header {
    position: fixed;
    z-index: 10;
    background: #FFFFFF;
    box-shadow: 0px 0px 24px 0px rgba(0, 56, 112, 0.1);
    height: 100px;
    width: 100%;
    top: 0;
    color: #333333;
    font-size: 28px;
    font-weight: 400;
    .headerMain {
      width: 100%;
      height: 100%
      display: flex;
      justify-content: space-between;
      align-items: center;
      .end {
        padding-right: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .userName {
          width: 90px
        }
        .status {
          width: 130px;
          margin: 0 35px 0 65px;
        }
        .money {
          width: 60px
        }
      }
      .start {
        padding-left: 50px;
      }
    }
  }
  .list {
    padding: 120px 30px 30px 30px;
    .tips {
      font-size: 26px;
    }
    .reward-item {
      margin-top: 30px;
      padding: 40px 30px;
      display: flex;
      background: #FFFFFF;
      border-radius: 10px;
      font-size: 28px;
      font-weight: 400;
      color: #333333;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        display: flex;
        align-items: center;
        overflow: hidden;
        width: 100%;
        .info {
          width: 100%;
          padding-right: 15px;
          max-height: 100px;
          white-space: wrap
          .name {
            width: 100%;
            word-break: break-all;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          .time {
            margin-top: 11px;
            color: #888888;
            font-size: 20px;
          }
        }
      }
      .right {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .userName {
          width: 145px;
          margin-left: 5px;
          overflow:hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          text-align: left;
        }
        .oldUser {
          // border-bottom: 1px solid red;
          color: red
        }
        .status {
          width: 115px;
          margin: 0 20px 0 5px;
          text-align: center;
        }
        .status_2 {
          color: #E20000;
        }
        .status_1, .status_4 {
          color: #888888;
        }
        .status_0, .status_3  {
          color: #368BFF;
        }
        .money {
          width: 60px;
          text-align: right;
        }
      }
    }
  }
}
</style>
